<template>
    <div>
         <div v-if="saveMessage !== ''" class="alert alert-primary alert-dismissible fade show" role="alert">
            {{saveMessage}}
            <button @click="clearSaveMessage" type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Language name</span>
                </div>
                <input class="form-control" v-model="name" type="text">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Language code</span>
                </div>
                <input class="form-control" v-model="code" type="text">
            </div>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">
                        Flag image
                        <img class="rounded-circle input-group" :src="flagImagePath">
                    </span>
                </div>
                <b-form-file accept="image/png" v-model="flagImage"></b-form-file>
            </div>
            <button @click="updateImage" class="btn btn-primary">Save</button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            name: '',
            code: '',
            flagImage: null,
            flagImagePath: '',
            saveMessage: '',
            imageVersion: null
        }
    },
    computed: {
        systemLanguages: function() {
            return this.$store.getters.systemLanguages
        }
    },
    methods: {
        getLanguage: function() {
            let langCode = this.code == '' ? this.$route.params.langCode : this.code;
            this.$http
            .get('/api/languages/get/' + langCode)
            .then(response => {
                let language = response.data;
                this.name = language.longTitle;
                this.code = language.title;
                this.flagImagePath = language.flagImagePath;
            })
        },
        updateImage: function() {
            let flag = this.flagImage
            let langCode = this.$route.params.langCode
            let image = new FormData()
            if (flag != null) {
                image.set('flag', flag, this.code)
                this.$http.put(`/api/languages/update-flag/${langCode}`, image)
                .then(response => {
                    /*
                      Adds version query param to the image path in order to prevent browser
                      to show cached image instead of the new one, on language modify
                    */
                    this.imageVersion = Math.random();
                    this.flagImagePath = this.setImageVersionToPath(this.flagImagePath, this.imageVersion);

                    this.editLanguage()
                    this.flagImage = null
                }).catch(error => {
                    this.saveMessage = 'There was a problem saving your changes'
                })
            } else {
                this.editLanguage()
            }
        },
        editLanguage: function() {
            let langCode = this.$route.params.langCode
            this.$store.dispatch("updateLanguage", {
                code: this.code,
                name: this.name,
                langCode: langCode,
                imageVersion: this.imageVersion
            }).then(response => {
                this.saveMessage = 'Language changed!';
            }).catch(error => {
                this.saveMessage = 'There was a problem saving your changes'
            });
        },
        clearSaveMessage: function(){
            this.saveMessage = ''
        },
        formatCode: function(value){
            this.code = value.toUpperCase().replace(/(\W|\d|_)/, '').substring(0, 2)
        },
        setImageVersionToPath: function(imagePath, version) {
            if (imagePath.includes('?version=')) {
                imagePath = imagePath.replace(/\?version=[0-9.]+/, '?version=' + version);
            } else {
                imagePath += '?version=' + version;
            }

            return imagePath;
        }
    },
    created: function() {
        this.getLanguage();
    },
    watch: {
        code: function(value) {
            this.formatCode(value)
        },
        name: function(value) {
            this.name = value.charAt(0).toUpperCase() + value.substring(1).toLowerCase()
        }
    }
}
</script>

<style lang="scss" scoped>
    div {
        span.input-group-text {
            width: 145px;
        }
    }
    .rounded-circle {
            height : 1.5rem;
            width : 1.5rem;
            margin-left: 0.5rem;
    }
</style>
